// HierarchyEdit.jsx
import React, { useState } from "react";
import api from "../../api";
import { ROLES, DEPARTMENTS } from "../../layouts/roles";

const HierarchyEdit = ({ user, onClose, showToast }) => {
  const [formData, setFormData] = useState({
    role: user.role || "",
    department: user.department || "",
    team: user.team || ""
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/userinfo/${user.id}`, formData);
      showToast("User updated successfully", "success");
      onClose();
    } catch (error) {
      console.error("Error updating user:", error);
      showToast("Error updating user", "error");
    }
  };

  return (
    <div className="hierarchy-edit modal">
      <h3>Edit Hierarchy for {`${user.first_name} ${user.last_name}`}</h3>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Role:</label>
          <select name="role" value={formData.role} onChange={handleChange}>
            {Object.values(ROLES).map((r) => (
              <option key={r} value={r}>{r}</option>
            ))}
          </select>
        </div>
        <div>
          <label>Department:</label>
          <select
            name="department"
            value={formData.department}
            onChange={handleChange}
          >
            {Object.values(DEPARTMENTS).map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label>Team (Team Lead ID):</label>
          <input
            type="text"
            name="team"
            value={formData.team}
            onChange={handleChange}
            placeholder="Enter team lead id"
          />
        </div>
        <div style={{ marginTop: "10px" }}>
          <button type="submit">Save</button>
          <button type="button" onClick={onClose} style={{ marginLeft: "10px" }}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default HierarchyEdit;
